/*
 * @Desc: 公用 接口的统一出口
 * @Author: 赵佳明
 * @Date: 2023-01-30 09:11:04
 * @LastEditors: 赵佳明
 * @LastEditTime: 2023-02-02 15:04:39
 * Copyright (c) 2023 山木枝(河北)技术服务有限公司, All Rights Reserved. 
 */
import axios from "../http"; // 导入http中创建的axios实例
import qs from "qs"; // 根据需求是否导入qs模块，把请求字段直接映射过来

const api = "/api/";

const common = {
  // 图片上传
  uploadBase64(params) {
    return axios.post(api + "common/uploadBase64", qs.stringify(params));
  },
};

// 导出接口
export default common;
